/* eslint-disable import/prefer-default-export */
/* 
import 'react-app-polyfill/stable';
import "babel-polyfill";
*/
import ScoreComponent from './components/ScoreComponent.react';
import Stave from './components/Stave';
import Orchestration from './components/Orchestration';
import Masking from './components/Masking';
import Pianoroll from './components/Pianoroll';
import Range from './components/Range';
import Edit from './components/Edit';
import Pianoinput from './components/Pianoinput';


export {
    ScoreComponent,
    Stave,
    Orchestration,
    Masking,
    Pianoroll,
    Range,
    Edit,
    Pianoinput,
};
